import { FieldError } from "react-hook-form";

import SkillsSearchDropdown from "./SkillsSearchDropdown";
import Chip, { ChipContainer } from "./Chip";
import { FormSearchDropdownOption } from "./FormSearchDropdown/FormSearchDropdown";
import FormInputLabel from "./FormInputLabel";


export type GigProductTypeInputProps = {
    addSkill: (skill: { id: string, name: string }) => void
    removeSkill: (index: number) => void
    skills?: { id: string, name: string }[]
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error?: any,
    showError?: boolean
    hideDropdown?: boolean
    tooltip?: string
}

const GigProductTypeInput = ({
    addSkill,
    removeSkill,
    skills,
    error,
    showError,
    hideDropdown,
    tooltip
}: GigProductTypeInputProps) => {
    const handleSelectSkill = (_: string, option: FormSearchDropdownOption | null) => {
        if (option === null) return;
        addSkill({
            id: option.value,
            name: option.label
        });
    };

    const handleRemoveSkill = (index: number) => {
        removeSkill(index);
    };

    const fieldError: FieldError | undefined = (error)?.message ? error as FieldError : undefined;

    if (!skills) return <>"Loading Insights workshop types..."</>;

    return (
        <div>
            {!hideDropdown && (
                <SkillsSearchDropdown
                    value={""}
                    required
                    onChange={handleSelectSkill}
                    disabled={skills.length === 1}
                    disabledSkillIds={skills.map(_ => _.id)}
                    error={showError ? fieldError : undefined}
                    tooltip={tooltip}
                />
            )}
            {hideDropdown && (
                <FormInputLabel required className="mt-6">Insights Workshop Type</FormInputLabel>
            )}
            <ChipContainer className={hideDropdown ? undefined : "pt-2"}>
                {skills.map((skill, index) => (
                    <Chip
                        key={skill.id}
                        label={skill.name}
                        onDelete={() => handleRemoveSkill(index)} />
                ))}
            </ChipContainer>
        </div>
    );
};

export default GigProductTypeInput;